import axios from "axios";
import { Dispatch } from "react";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { DownloadArchiveFromManifest } from "../../../helper/archive/methods";

export const FolderDownload = {
  Download: async (state: UserStateInterface, dispatch: Dispatch<any>) => {
    let serverResponse;
    if (state.data) {
      const folderDownloadData = state.data;
      const url = "./php/common/downloader-proxy.php";
      await axios
        .post(url, folderDownloadData)
        .then(async (response) => {
          // A folder comes back as a manifest of presigned URLs, which the
          // browser fetches and bundles itself. Nothing is zipped or staged
          // server side any more.
          if (response.data.header === "manifest") {
            dispatch({ type: "RESPONSE", response: "ARCHIVING" });

            await DownloadArchiveFromManifest(response.data.data, dispatch);

            serverResponse = "";
          } else {
            serverResponse = response.data;
          }
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        })
        .finally(() => {
          dispatch({ type: "ARCHIVE_PROGRESS", payload: null });
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }

    return serverResponse;
  },
};
